<template>
  <div class="chapters-block">
    <h3 class="chapters-block-title">卷目录</h3>
    <div class="volume-groups">
      <button
        v-for="(grp, idx) in volumeGroups"
        :key="idx"
        type="button"
        class="volume-group-btn"
        :class="{ active: currentVolumeGroupIndex === idx }"
        @click="currentVolumeGroupIndex = idx"
      >
        {{ grp.label }}
      </button>
    </div>
    <div class="chapters-container">
      <el-button
        type="info"
        plain
        v-for="vol in displayedChapters"
        :key="vol.id || vol.num"
        class="chapter-button"
        :class="{
          'has-progress': hasVolumeProgress(vol.num),
          'is-need-login': getVolumeAccess(vol.num) === 'NEED_LOGIN',
          'is-locked': getVolumeAccess(vol.num) === 'LOCKED',
          'is-unlocked': getVolumeAccess(vol.num) === 'UNLOCKED',
        }"
        :style="hasVolumeProgress(vol.num) ? {
          '--progress-percent': (getVolumeProgress(vol.num) * 100) + '%',
          'background': `linear-gradient(to right, #a5d6a7 ${getVolumeProgress(vol.num) * 100}%, #f5f5f5 ${getVolumeProgress(vol.num) * 100}%)`,
          'border-color': '#7dd3a0',
          'color': '#333'
        } : {}"
        :data-vol="vol.num"
        @click="goToReadingPage(vol)"
      >
        <el-tooltip
          v-if="isVolumeRestricted(vol.num)"
          class="box-item"
          effect="dark"
          content="登录后观看"
          placement="top"
        >
          <span class="chapter-vol-label" :title="formatVolumeLabel(vol)">{{ formatVolumeLabel(vol) }}</span>
        </el-tooltip>
        <template v-else>
          <span class="chapter-vol-label" :title="formatVolumeLabel(vol)">{{ formatVolumeLabel(vol) }}</span>
          <AppIcon
            v-if="getVolumeAccess(vol.num) === 'LOCKED'"
            name="lock"
            size="sm"
            class="chapter-lock-icon"
          />
          <AppIcon
            v-else-if="getVolumeAccess(vol.num) === 'UNLOCKED'"
            name="unlock"
            size="sm"
            class="chapter-lock-icon"
          />
        </template>
      </el-button>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'

const currentVolumeGroupIndex = defineModel('currentVolumeGroupIndex', { type: Number, default: 0 })

defineProps({
  volumeGroups: { type: Array, default: () => [] },
  displayedChapters: { type: Array, default: () => [] },
  hasVolumeProgress: { type: Function, required: true },
  getVolumeProgress: { type: Function, required: true },
  isVolumeRestricted: { type: Function, required: true },
  getVolumeAccess: { type: Function, required: true },
  goToReadingPage: { type: Function, required: true },
})

/**
 * 卷按钮文案：卷号 + title，缺标题时回退「第 n 卷」
 * @param {{ num?: number|string, title?: string }} vol
 * @returns {string}
 */
function formatVolumeLabel(vol) {
  const num = vol?.num
  const title = typeof vol?.title === 'string' ? vol.title.trim() : ''
  if (title) return `${num}. ${title}`
  return `第 ${num} 卷`
}
</script>
